module.exports = __webpack_public_path__ + "static/media/members.3bc59503.svg";